import * as React from 'react';
import './index.scss';
import { Input, Select, Button, Divider, Typography, Avatar, Space, Segmented, Card, Dropdown, MenuProps, Row, Col, notification, Form, Mentions, Flex } from 'antd';
import { UserOutlined, DownOutlined } from '@ant-design/icons';
import TextEditor from './textedtior';
import { useDispatch } from 'react-redux';
import { getData } from '../../../../actions/apiCall';
import { postData, putData } from '../../../../actions/developer';
import { constants } from '../../../../constants/common';
import InfiniteScrollList from '../../../../components/Forms/ListView/InfiniteScrollList';
import timeAgo from '../../../../constants/functions';

const { Title, Text, Paragraph } = Typography;
const { TextArea } = Input;
const { Option } = Select;
const { useForm } = Form;

interface SprintComponentProps {
    selectedTask: string;
}

interface TaskProps {
    _id: string;
    assignee: string;
    columnId: string;
    sprintId: string;
    title: string;
    projectId: string;
    order: number;
}

const IssueComponent: React.FC<SprintComponentProps> = ({
    selectedTask
}) => {
    const [editDescription, setEditDiscription] = React.useState(false);
    const [discriptions, setDiscription] = React.useState('<p>No Details</p>');
    const [taskDetails, setTaskDetails] = React.useState<TaskProps>(null);
    const [loading, setLoading] = React.useState(false);
    const [selectedStatus, setSelectedStatus] = React.useState(null);
    const [columns, setColumns] = React.useState([]);
    const [teamMembers, setTeamMembers] = React.useState([]);
    const [text, setCommentText] = React.useState('');
    const [viewType, setViewType] = React.useState('Comments');
    const [reloadComments, setReloadComments] = React.useState(false);
    const [reloadHistotry, setReloadHistotry] = React.useState(false);

    const dispatch = useDispatch();
    const [form] = useForm();
    const [commentForm] = useForm();

    React.useEffect(() => {
        if (selectedTask) {
            getTaskDetails(selectedTask);
        }
    }, [selectedTask]);

    const getTeamMembers = async (projectId) => {
        const resData = await dispatch(getData(`/teams/${projectId}`));
        if (resData) {
            setTeamMembers(resData.data);
        }
    }

    const getTaskDetails = async (taskId: string) => {
        const resData = await dispatch(getData('/tasks/details/' + taskId));
        if (resData) {
            setTaskDetails(resData.data);
            form.setFieldsValue({
                assignee: resData.data?.assignee ?? "",
                reporter: resData.data?.reporter ?? "",
                priority: resData.data?.priority,
                label: resData.data?.label,
                storyPoints: resData.data?.storyPoints,
                // parentTaskId: resData.data?.parentTaskId
            });
            getColumns(resData.data?.projectId);
            getTeamMembers(resData.data?.projectId);
            setSelectedStatus(resData.data?.columnId);
            setDiscription(resData.data?.description);
        }
    };

    const onUpdate = async (e) => {
        const resData = await dispatch(putData(`/tasks/${taskDetails._id}`, e));
        if (!resData) {
            notification.error({ message: 'Error', description: 'Failed to update task status' });
        } else {
            setReloadHistotry(true);
        }
    }

    const onClickContent = () => {
        setEditDiscription(true);
    };

    const updateTaskStatus = async (value, task) => {
        if (!value || value === task.title || value === '') {
            return
        }
        const resData = await dispatch(putData(`/tasks/${task._id}`, { title: value }));
        if (!resData) {
            notification.error({ message: 'Error', description: 'Failed to update task status' });
        } else {
            setReloadHistotry(true);
            getTaskDetails(task._id);
        }
    }

    const getColumns = async (selectedTask) => {
        console.log(selectedTask);
        const resData = await dispatch(getData(`/columns/${selectedTask}`));
        if (resData) {
            setColumns(resData.data);
        }
    }

    const onSaveDescription = async () => {
        setLoading(true);
        try {
            const resData = await dispatch(putData(`/tasks/${taskDetails._id}`, { description: discriptions }));
            if (!resData) {
                notification.error({ message: 'Error', description: 'Failed to update task status' });
            } else {
                setReloadHistotry(true);
            }
            setEditDiscription(false);
        } catch (error) {
            notification.error({ message: 'Error', description: 'Failed to update task status' });
        } finally {
            setLoading(false);
            getTaskDetails(taskDetails._id);
        }
    }

    const handleMenuClick: MenuProps['onClick'] = (e) => {
        onUpdate({ columnId: e.key });
        setSelectedStatus(e.key);
    };

    const items: MenuProps['items'] = columns.map(ele => ({
        label: ele?.name,
        key: ele?._id,
        icon: <UserOutlined />,
    }))

    const menuProps = {
        items,
        onClick: handleMenuClick,
    };

    const onSubmit = async (e) => {
        console.log(e);
        const resData = await dispatch(postData(`/task-comments`, { message: e.comment, taskId: taskDetails._id }));
        if (resData.code == 200) {
            setCommentText('');
            commentForm.resetFields();
            setReloadComments(true);
        }
    }


    const Activities = () => {
        return <>
            <Space direction='vertical' style={{ width: '100%' }}>
                <Title level={5}>Activity</Title>
                <Space direction='horizontal'>
                    Show: <Segmented
                        options={['Comments', 'History']}
                        onChange={(value) => {
                            setViewType(value);
                        }}
                    />
                </Space>
            </Space>
            {viewType == 'Comments' && <div style={{ marginTop: 10 }}>
                <Form form={commentForm}
                    onFinish={(e) => onSubmit(e)}
                    onValuesChange={(e) => {
                        if (Object.hasOwn(e, 'comment')) {
                            setCommentText(e.comment);
                        }
                    }}
                    layout='vertical'>
                    <Flex justify='start' style={{ width: '100%' }}>
                        <Avatar icon={<UserOutlined />} />
                        <Form.Item name='comment' style={{ width: '100%' }}>
                            <TextArea key={'comment'}
                                name='comment'
                                placeholder="Add a comment..." rows={2}
                                style={{ width: '100%', marginLeft: 10 }}
                            />
                        </Form.Item>
                    </Flex>
                    <Form.Item>
                        {text != '' && < Space direction='horizontal' style={{ marginTop: 10, marginLeft: 40 }}>
                            <Button type='primary' htmlType='submit'>Save</Button>
                            <Button htmlType='reset' onClick={() => {
                                setCommentText('')
                                commentForm.resetFields();
                            }}>Cancel</Button>
                        </Space>}
                    </Form.Item>
                </Form>
                {taskDetails?._id && <InfiniteScrollList
                    height={300}
                    reload={reloadComments}
                    onLoaded={() => setReloadComments(false)}
                    apiUrl={'/task-comments?taskId=' + taskDetails._id}
                    renderItem={(item) => <Space direction='vertical' size={[0, 0]} style={{ width: '100%' }}>
                        <Space direction='horizontal' style={{ width: '100%' }} size={[0, 0]}>
                            <Avatar icon={<UserOutlined />} />
                            <Space direction='vertical' style={{ marginLeft: 10 }} size={[0, 0]}>
                                <Text strong>{constants.GET_FULL_NAME(item?.addedBy)}</Text>
                                <Text type='secondary'>{timeAgo(item?.createdAt)}</Text>
                            </Space>
                        </Space>
                        <div style={{ marginLeft: 40, marginTop: 0, marginBottom: 10 }}>
                            <Paragraph ellipsis={{ rows: 3, expandable: true }}>{item?.message}</Paragraph>
                        </div>
                    </Space>}
                />}
            </div>}
            {viewType == 'History' && <div style={{ marginTop: 10 }}>
                {taskDetails?._id && <InfiniteScrollList
                    height={300}
                    reload={reloadHistotry}
                    onLoaded={() => setReloadHistotry(false)}
                    apiUrl={'/task-history?taskId=' + taskDetails._id}
                    renderItem={(item) => <Space direction='vertical' size={[0, 0]} style={{ width: '100%' }}>
                        <Space direction='horizontal' style={{ width: '100%' }} size={[0, 0]}>
                            <Avatar icon={!item?.addedBy?.avatar ? <UserOutlined /> : ''}
                                src={`${process.env.FILE_URL}${item?.addedBy?.avatar}`}
                                onError={() => true}
                            >
                                {!item?.addedBy?.avatar ? [item?.addedBy?.firstName[0], item?.addedBy?.lastName[0]].join("") : null}
                            </Avatar>
                            <Space direction='vertical' style={{ marginLeft: 10 }} size={[0, 0]}>
                                <Text strong>{constants.GET_FULL_NAME(item?.addedBy)}</Text>
                                <Text type='secondary'>{timeAgo(item?.createdAt)}</Text>
                            </Space>
                        </Space>
                        <div style={{ marginLeft: 40, marginTop: 0, marginBottom: 10 }}>
                            <Paragraph ellipsis={{ rows: 3, expandable: true }}>{item?.message}</Paragraph>
                        </div>
                    </Space>}
                />}
            </div >}
        </>
    }

    return (
        <Card bordered={false}>
            <Row gutter={[16, 16]}>
                <Col span={12}>
                    <div style={{ flex: 2 }}>
                        <Title
                            level={4}
                            editable={{
                                tooltip: 'click to edit text',
                                onChange: (e) => updateTaskStatus(e, taskDetails),
                                triggerType: ['text'],
                            }}
                        >
                            {taskDetails?.title}
                        </Title>

                        <Title level={5}>Description</Title>
                        {!editDescription ? <div
                            onClick={onClickContent}
                            dangerouslySetInnerHTML={{ __html: discriptions ?? '<p><br/></p>' }}
                        /> : <TextEditor
                            loading={loading}
                            getEditor={() => { }}
                            defaultValue={discriptions}
                            onChange={(e) => { setDiscription(e); }}
                            onSave={() => onSaveDescription()}
                        />}
                        <Divider />
                        {Activities()}
                    </div>
                </Col>
                <Col span={12}>
                    <div style={{ flex: 1 }}>
                        <Space direction='vertical' style={{ width: '100%' }}>
                            <Space direction='horizontal'>
                                {selectedStatus && <Dropdown menu={menuProps}>
                                    <Button>
                                        <Space>
                                            {columns.find(ele => ele._id === selectedStatus)?.name}
                                            <DownOutlined />
                                        </Space>
                                    </Button>
                                </Dropdown>}
                            </Space>
                            <Card
                                title={<Title level={5}>Details</Title>}
                                bordered
                            >
                                <Form form={form} layout='vertical'
                                    onValuesChange={(e) => {
                                        console.log(e);
                                        onUpdate(e);
                                    }}
                                >
                                    <Row
                                        gutter={[16, 16]}
                                        style={{ width: '100%' }}
                                    >
                                        <Col span={8} className='select_assignee'>
                                            <Text>Assignee</Text>
                                        </Col>
                                        <Col span={16}>
                                            <Form.Item
                                                name='assignee'
                                            >
                                                <Select
                                                    style={{ width: '100%' }}
                                                    showSearch
                                                >
                                                    <Option value="">
                                                        <Space direction='horizontal'>
                                                            <Avatar size={'small'} icon={<UserOutlined />} /> Unassigned
                                                        </Space>
                                                    </Option>
                                                    {teamMembers && teamMembers.map(ele => <Option value={ele?._id}>
                                                        <Space direction='horizontal'>
                                                            <Avatar size={'small'} src={`${process.env.FILE_URL}${ele?.teamMember?.avatar}`}>
                                                                {!ele?.teamMember?.avatar ?
                                                                    [ele?.teamMember?.firstName[0], ele?.teamMember?.lastName[0]].join("") : null}
                                                            </Avatar>
                                                            {constants.GET_FULL_NAME(ele?.teamMember)}
                                                        </Space>
                                                    </Option>)}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={8}>
                                            <Text>Labels</Text>
                                        </Col>
                                        <Col span={16}>
                                            <Form.Item
                                                name='label'
                                            >
                                                <Select showSearch allowClear placeholder="Add labels" style={{ width: '100%' }} >
                                                    {['bug', 'feature', 'enhancement', 'backend', 'frontend', 'design', 'documentation'].map(ele => <Option value={ele}>{ele}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        {/* <Col span={8}>
                                            <Text>Parent</Text>
                                        </Col>
                                        <Col span={16}>
                                            <Form.Item
                                                name='parentTaskId'
                                            >
                                                <Input placeholder="Link parent issue" />
                                            </Form.Item>
                                        </Col> */}
                                        <Col span={8}>
                                            <Text>Story Point</Text>
                                        </Col>
                                        <Col span={16}>
                                            <Form.Item
                                                name='storyPoints'
                                            >
                                                <Input placeholder="1" />
                                            </Form.Item>
                                        </Col>
                                        <Col span={8} className='select_assignee'>
                                            <Text>Priority</Text>
                                        </Col>
                                        <Col span={16} >
                                            <Form.Item
                                                name='priority'
                                            >
                                                <Select
                                                    defaultValue={""}
                                                    style={{ width: '100%' }}
                                                    showSearch
                                                >
                                                    {['low', 'medium', 'high'].map(ele => <Option value={ele}>{ele}</Option>)}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Title level={5}>Development</Title>
                                        </Col>
                                        <Col span={8} className='select_assignee'>
                                            <Text>Reporter</Text>
                                        </Col>
                                        <Col span={16} >
                                            <Form.Item
                                                name='reporter'
                                            >
                                                <Select
                                                    defaultValue={""}
                                                    style={{ width: '100%' }}
                                                    showSearch
                                                >
                                                    <Option value="">
                                                        <Space direction='horizontal'>
                                                            <Avatar size={'small'} icon={<UserOutlined />} /> Unassigned
                                                        </Space>
                                                    </Option>
                                                    {teamMembers && teamMembers.map(ele => <Option value={ele?._id}>
                                                        <Space direction='horizontal'>
                                                            <Avatar size={'small'} src={`${process.env.FILE_URL}${ele?.teamMember?.avatar}`}>
                                                                {!ele?.teamMember?.avatar ?
                                                                    [ele?.teamMember?.firstName[0], ele?.teamMember?.lastName[0]].join("") : null}
                                                            </Avatar>
                                                            {constants.GET_FULL_NAME(ele?.teamMember)}
                                                        </Space>
                                                    </Option>)}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Form>
                            </Card>
                        </Space>
                    </div>
                </Col>
            </Row>
        </Card>
    );
};

export default IssueComponent;
